<template>
  <div class="error">
    404: Not Found
  </div>
</template>

<script>
export default {
  name: 'error'
}
</script>

<style scoped lang="scss">
.error {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// Error.vue?1fbd7f17